import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {
  @Input() title; 
  @Input() url = '/';

    constructor(private router: Router){}

  goBack(){
   this.router.navigateByUrl(this.url);
  }

}
